import { useState, useEffect, useRef } from "react";
import {
  FindSelectionLabel,
  ValueHighlight,
  TagCloseButton,
  ButtonDropdownAnchor,
} from "./FilterControls.styles";
import { SecondaryButton } from "src/components/Buttons";
import { CloseIcon, SearchIcon } from "src/assets/icons";
import { StyledInput, Wrapper, ButtonWrapper } from "./FindTag.styles";
import { Dropdown } from "./Dropdown";
import { useClickOutsideModalListener } from "src/hooks/useClickOutsideModalListener";
import { useTableFilterContext } from "src/context";

export default () => {
  const {
    textSearchField,
    setTextSearchField,
    textSearchValue,
    setTextSearchValue,
  } = useTableFilterContext();
  const [userInput, setUserInput] = useState(textSearchValue);
  const dropdownRef = useRef(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useClickOutsideModalListener(dropdownRef, () => {
    setIsDropdownOpen(false);
    setUserInput(null);
  });

  useEffect(() => {
    setUserInput(textSearchValue);
    setIsDropdownOpen(false);
  }, [textSearchValue]);

  useEffect(() => {
    if (isDropdownOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isDropdownOpen]);

  if (!textSearchField || !textSearchValue) return null;

  const onDelete = () => {
    setTextSearchField(null);
    setTextSearchValue(null);
  };

  const applySearch = () => {
    setTextSearchValue(userInput);
    setIsDropdownOpen(false);
  };
  return (
    <ButtonDropdownAnchor>
      <SecondaryButton onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
        <SearchIcon />
        <FindSelectionLabel>
          {textSearchField.replace("_", " ")} contains:
        </FindSelectionLabel>{" "}
        <ValueHighlight>{textSearchValue}</ValueHighlight>
        <TagCloseButton type="button" onClick={onDelete}>
          <CloseIcon />
        </TagCloseButton>
      </SecondaryButton>
      <Dropdown clickHandleRef={dropdownRef} show={isDropdownOpen}>
        <Wrapper>
          <StyledInput
            ref={inputRef}
            value={userInput ?? ""}
            onChange={(evt) => setUserInput(evt.target.value)}
            onKeyDown={(evt) => {
              if (evt.key === "Enter") {
                evt.preventDefault();
                applySearch();
              }
            }}
          />
          <ButtonWrapper>
            <SecondaryButton onClick={applySearch}>Apply</SecondaryButton>
          </ButtonWrapper>
        </Wrapper>
      </Dropdown>
    </ButtonDropdownAnchor>
  );
};
